









































import { Component, Vue } from 'vue-property-decorator';
import { ALL_SUBUNITS } from '@/queries/SubUnit';
import SubUnitNewButton from '@/components/SubUnit/SubUnitNewButton.vue';
import SubUnitEditButton from '@/components/SubUnit/SubUnitEditButton.vue';
import SubUnitDeleteButton from '@/components/SubUnit/SubUnitDeleteButton.vue';
import SubUnitShowButton from '@/components/SubUnit/SubUnitShowButton.vue';

@Component({
  components: {
    SubUnitNewButton,
    SubUnitEditButton,
    SubUnitDeleteButton,
    SubUnitShowButton,
  },
})
export default class SubUnitList extends Vue {
  private ALL_SUBUNITS = ALL_SUBUNITS;
}
